import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Typography,
  styled,
} from '@mui/material';

export const DisagreeButton = styled(Button)(() => ({
  color: '#662B5C',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: '24px',
  textTransform: 'inherit',
  borderRadius: '44px',
  background: 'rgba(237, 194, 226, 0.48)',
  '&:hover': {
    background: 'rgba(237, 194, 226, 0.48)',
  },
}));
export const AgreeButton = styled(Button)(() => ({
  display: 'flex',
  padding: '7px 32px 9px 32px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  borderRadius: '44px',
  color: '#FFF7FC',
  textAlign: 'center',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: '24px',
  background: '#A03A7E',
  textTransform: 'inherit',
}));
export const DialogTitleStyle = styled(DialogTitle)(() => ({
  color: '#A03A7E',
  fontSize: '24px',
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: '36px',
}));

export const DialogContainer = styled(Dialog)(() => ({
  background: 'rgba(92, 89, 92, 0.88)',
  backdropFilter: 'blur(4px)',
  boxShadow: '0px 1px 3px 1px rgba(0, 0, 0, 0.15)',
  marginTop: '-10%',
}));

export const ActionContainer = styled(DialogActions)(() => ({
  display: 'flex',
  justifyContent: 'flex-start',
  marginInline: '20px',
  marginBottom: '32px',
}));
export const ContentDialogText = styled(Typography)(() => ({
  color: '#616161',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '24px',
}));
